/// <reference types="@types/googlemaps" />

export class ImageOverlay extends google.maps.OverlayView {
  private bounds: google.maps.LatLngBounds;
  private source: string | SVGSVGElement;
  type: 'fromSrc' | 'fromSvg';
  private div?: HTMLElement;
  constructor(
    bounds: google.maps.LatLngBounds,
    source: string | SVGSVGElement,
    type: 'fromSrc' | 'fromSvg' = 'fromSrc'
  ) {
    super();
    this.type = type;
    this.bounds = bounds;
    this.source = source;
  }

  onAdd() {
    this.div = document.createElement('div');
    this.div.style.borderStyle = 'none';
    this.div.style.borderWidth = '0px';
    this.div.style.position = 'absolute';

    // Create the img element and attach it to the div.
    const img = document.createElement('img');

    if (this.type === 'fromSrc') {
      img.src = this.source as string;
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.position = 'absolute';
      img.id = 'overlay-custom';

      this.div.appendChild(img);

      // Add the element to the "overlayLayer" pane.
      const panes = this.getPanes();

      panes.overlayLayer.appendChild(this.div);
      img.addEventListener('load', () => {
        google.maps.event.trigger(this, 'imgLoaded');
      });
    } else {
      // Load the inline svg element and attach it to the div.
      var svg: any = this.source;
      svg.style.width = '100%';
      svg.style.height = '100%';
      svg.id = 'overlay-custom';

      this.div.appendChild(svg);
      // Add the element to the "overlayLayer" pane.
      var panes = this.getPanes();
      panes.overlayLayer.appendChild(this.div);
    }
  }

  draw() {
    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    const overlayProjection = this.getProjection();

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
    const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());

    // Resize the image's div to fit the indicated dimensions.

    if (this.div) {
      this.div.style.left = sw.x + 'px';
      this.div.style.top = ne.y + 'px';
      this.div.style.width = ne.x - sw.x + 'px';
      this.div.style.height = sw.y - ne.y + 'px';
    }
  }

  onRemove() {
    if (this.div) {
      (this.div.parentNode as HTMLElement).removeChild(this.div);
      delete this.div;
    }
  }
  /*  private addCustomListener(div: HTMLElement) {
    this.getPanes().overlayMouseTarget.appendChild(div);

    // Add a listener - we'll accept clicks anywhere on this div, but you may want
    // to validate the click i.e. verify it occurred in some portion of your overlay.
    google.maps.event.addDomListener(div, 'click', () => {
      google.maps.event.trigger(this, 'clickedDiv', div);
    });
  } */
}
